import React from 'react';

import { observer } from 'mobx-react';
import { Button, DropdownMenu } from '@bringg/react-components';
import { GroupMode } from '@bringg/types';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { useMonitoringTranslations } from '@bringg-frontend/monitoring-shared';

import useOrderExplorerStore from '../../stores/use-order-explorer-store';
import { groupToggleService } from '../../data/group-toggle-service';

import styles from './order-explorer-grouping.module.scss';

const OrderExplorerGrouping = () => {
	const {
		groupBy: { driver, team, teamAndDriver, route, teamAndRoute, noGrouping }
	} = useMonitoringTranslations();
	const { orderExplorerStore } = useOrderExplorerStore();

	const options = [
		{
			label: route,
			key: GroupMode.Route
		},
		{
			label: teamAndRoute,
			key: GroupMode.TeamRoute
		},
		{
			label: team,
			key: GroupMode.Team
		},
		{
			label: teamAndDriver,
			key: GroupMode.TeamDriver
		},
		{
			label: driver,
			key: GroupMode.Driver
		},
		{
			label: noGrouping,
			key: GroupMode.None
		}
	];

	const selectGroup = (key: string | number) => {
		if (key !== orderExplorerStore.currentTableDefinition?.groupMode) {
			groupToggleService.changeMode(key as GroupMode);

			getRootEnv().dashboardSdk.sdk.userAnalytics.trackEvent({
				key: `OM:group_by-${key}`
			});
		}
	};

	const groupByValueKey = orderExplorerStore.currentTableDefinition?.groupMode || GroupMode.TeamRoute;

	return (
		<DropdownMenu
			items={options}
			trigger={['click']}
			onMenuSelect={selectGroup}
			menuOptions={{ selectable: true, defaultSelectedKeys: [groupByValueKey] }}
			offset={[0, 4]}
			popoverMatchTriggerWidth
		>
			<Button
				type="regular"
				className={styles.groupByButton}
				icon={<BringgIcon iconName={BringgFontIcons.GroupBy} />}
				data-test-id="order-explorer-grouping"
			>
				{options.find(option => option.key === groupByValueKey).label}
			</Button>
		</DropdownMenu>
	);
};

export default observer(OrderExplorerGrouping);
